import { doesExist } from "@shared/backend/entity-security/does-exist";
import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { canManageBackgroundImages } from "@shared/config/background-image-config";
import { Roles } from "@shared/Roles";
import { Allow, remult } from "remult";
import { User } from "../user";
import { type Image } from "./entity";

export const ImageEntityConfig: HyperEntityConfig<Image> = {
  allowApiRead: Allow.authenticated,
  allowApiCrud: [
    Roles.Admin,
    Roles.SuperAdmin,
    Roles.SuperDuperAdmin,
    Roles.Manager,
    Roles.User,
  ],
  apiPrefilterPerRole: (filter) => {
    if (!remult.user) return;

    filter(Roles.All, true);
  },

  allowInsertPerRole(allow) {
    allow(Roles.OrganizationManagers, true);

    allow(Roles.User, (entity) => !entity.organization);
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.OrganizationManagers, (entity) => {
      if (entity.organizationId !== remult.user!.organizationId) return false;
      if (entity.isBackground) {
        return canManageBackgroundImages(
          (remult.user as { phoneNumber?: string } | undefined)?.phoneNumber,
          remult.user?.roles,
        );
      }
      return true;
    });

    allow(
      Roles.User,
      (entity) =>
        !entity.organization &&
        doesExist(User, {
          id: remult.user!.id,
          profileImageId: entity.id,
        }),
    );
  },
};
